// extracted by mini-css-extract-plugin
module.exports = {"mantine-Modal-content":"styles_mantine-Modal-content__9klN6","mantine-Modal-body":"styles_mantine-Modal-body__M8EQM"};